import React from 'react';
import Icon from 'components/lib/icons/icon';

export default function CopyIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
        <path
          clipRule="evenodd"
          d="M8 2H13C13.5523 2 14 2.44772 14 3V10C14 10.5523 13.5523 11 13 11H8C7.44772 11 7 10.5523 7 10V3C7 2.44772 7.44772 2 8 2ZM6 3C6 1.89543 6.89543 1 8 1H13C14.1046 1 15 1.89543 15 3V10C15 11.1046 14.1046 12 13 12H8C6.89543 12 6 11.1046 6 10V3ZM1.5 6C1.5 5.17157 2.17157 4.5 3 4.5H4.5C4.77614 4.5 5 4.27614 5 4C5 3.72386 4.77614 3.5 4.5 3.5H3C1.61929 3.5 0.5 4.61929 0.5 6V13C0.5 14.3807 1.61929 15.5 3 15.5H8C9.38071 15.5 10.5 14.3807 10.5 13C10.5 12.7239 10.2761 12.5 10 12.5C9.72386 12.5 9.5 12.7239 9.5 13C9.5 13.8284 8.82843 14.5 8 14.5H3C2.17157 14.5 1.5 13.8284 1.5 13V6Z"
          fill="#9C9C9C"
          fillRule="evenodd"
        />
      </svg>
    </Icon>
  );
}
